import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import InitialSDK from './initial-sdk.md';
import ExpressEditorCodeBlock from "./express-editor-code-block.md";
import QuickActionCodeBlock from "./quick-action-code-block.md";
import TextToImageCodeBlock from "./text-to-image-code-block.md";
import ImageEditingCodeBlock from "./image-editing-code-block.md";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DCSummaryBlock = makeShortcode("DCSummaryBlock");
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DCSummaryBlock slots="heading , text , buttons" background="rgb(31, 42, 73)" buttonPositionRight className="design-features-code-block" mdxType="DCSummaryBlock" />
    <h2 {...{
      "id": "designed-for-developers"
    }}>{`Designed for developers`}</h2>
    <p>{`The Adobe Express Embed SDK integrates Adobe Express editing capabilities and content in your web application with just a few lines of code.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/express/embed-sdk/docs/guides/"
        }}>{`View documentation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://demo.expressembed.com/"
        }}>{`Try the demo`}</a></li>
    </ul>
    <TabsBlock orientation="vertical" slots="heading, image, content" repeat="4" theme="dark" className='bgBlue' mdxType="TabsBlock" />
    <h2 {...{
      "id": "initialize-sdk"
    }}>{`Initialize SDK`}</h2>
    <p><img parentName="p" {...{
        "src": "/express/embed-sdk/assets/d99fb4118c89768292cd5a73ea3af533/initialize-SDK.svg",
        "alt": "Code for initializing SDK"
      }}></img></p>
    <InitialSDK mdxType="InitialSDK" />
    <h3 {...{
      "id": "full-editor"
    }}>{`Full editor`}</h3>
    <p><img parentName="p" {...{
        "src": "/express/embed-sdk/assets/732b1da86001db4d1dbce2774b8894a4/Express-Editor.svg",
        "alt": "Code to invoke full editor"
      }}></img></p>
    <ExpressEditorCodeBlock mdxType="ExpressEditorCodeBlock" />
    <h3 {...{
      "id": "quick-actions"
    }}>{`Quick actions`}</h3>
    <p><img parentName="p" {...{
        "src": "/express/embed-sdk/assets/81d5b645b23b9a1ff151ac59874ca86b/quick-actions.svg",
        "alt": "Code to invoke quick actions"
      }}></img></p>
    <QuickActionCodeBlock mdxType="QuickActionCodeBlock" />
    <h3 {...{
      "id": "generate-image-module"
    }}>{`Generate image module`}</h3>
    <p><img parentName="p" {...{
        "src": "/express/embed-sdk/assets/6b04f0e35804b1b7c409baaa88b4bedc/SX_AITextToImage_18_N.svg",
        "alt": "Code to invoke generate image module"
      }}></img></p>
    <TextToImageCodeBlock mdxType="TextToImageCodeBlock" />
    {/* ### Image editing module
     ![Code to invoke Image editing module](../images/SX_MediaFileEdit_18_N.svg)
     <ImageEditingCodeBlock/> */}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      